module.exports = __webpack_public_path__ + "static/img/activityImage.8832e40e.png";